const state= {
    Items:{
        data:[],
        total:0,
        pages: {
            page:1,
            totalPage : 1,
            limit:25,
            filter:{}
        },
    },
    Loadings:{
        list: false,
        detail: false,
    },
    Item: null,
};

const getters = {
    Items : (state) => state.Items,
    Loadings : (state) => state.Loadings,
    Item : (state) => state.Item,
};

const actions = {
    async saveMeterReadingLog({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios(`/api/meter-reading-logs`, {
                method: "POST",
                data : params,
                headers: {
                    Accept: "application/json",
                },
            })
            .then(response => {
                resolve( response );
            })
            .catch(error => reject( error ));
        });
    },
    async updateMeterReadingLog({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios(`/api/meter-reading-logs/${params.id}`, {
                method: "PUT",
                data : params.data,
                headers: {
                    Accept: "application/json",
                },
            })
            .then(response => {
                resolve( response );
            })
            .catch(error => reject( error ));
        });
    },
    async getItem({commit}, params){
        return new Promise (( resolve, reject ) => {
            commit( 'setLoadings', {key:"detail",val:true});
            global.axios.get(`/api/meter-reading-logs/${params}`)
                .then(response => {
                    commit( 'setLoadings', {key:"detail",val:false});
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },
    async getList({commit}, params){
        commit( 'setLoadings', {key:"list",val:true});
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/meter-reading-logs`, {params:params})
            .then(response => {
                commit( 'setLoadings', {key:"list",val:false});
                response.data.data.pages = params
                commit( 'setListItems', response.data.data );
                resolve( response );
            })
            .catch(error => reject( error ));
        });
    },
    async exportFile({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/meter-reading-logs/export`, {
                params:params,
                responseType: 'blob'
            })
            .then(response => {
                resolve( response );
            })
            .catch(error => reject( error ));
        });
    }
};

const mutations = {
    setListItems (state,data) {
        data.pages.totalPage = Math.ceil(data.total / data.pages.limit )
        state.Items.data = data.items
        state.Items.total = data.total
        state.Items.pages = data.pages
    },
    setLoadings (state,data) {
        state.Loadings[data.key] = data.val;
    },
    setTotalItems(state, data) {
        state.Items.total = data;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}